import React, { Fragment } from 'react';
import { Header, Button, Grid, Segment, Image, Loader, Icon, Table, Form, Popup, Checkbox } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

import PersonBasicInfoTable from './PersonBasicInfoTable';
import PreviousEducation from './PreviousEducationTable';
import CurrentStudyTable from './CurrentStudyTable';
import ContactFormEditable from '../util/ContactFormEditable';
import './PersonalInfo.css';
import request from '../util/request';
import { fetchPersonInfo, fetchCurrentStudyProgramInfo, addContact, deleteContact } from './request';
import { RightHeaderWithButton, IconHeader } from '../Professor/ProfessorInputGrades/css';
import StudentEdit from './../StudentService/StudentCreateAndEdit/StudentEdit';
import AccountInfo from './AccountInfo';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


/* eslint-disable eqeqeq, prefer-destructuring */


// const formatContacts = (contacts, contactTypes) => {
//     const c1 = contacts.map(c => ({
//         id: c.id,
//         contactType: contactTypes.find(el => el.text == c.type).value || null,
//         value: c.value
//     }));
//     return c1;
// };

// FIXME: role defaults to student, if employee pass isEmployee prop
export default class PersonalInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeRole: '',
            currentStudyProgramInfo: {},
            faculties: [],
            departments: [],
            // error handling
            error: false,
            errorText: '',

            contactEditMode: false,
            contactTypes: [],
            personData: {},
            loading: true,
            step: 0,
            src: null,
            accountMail: null,
            editAccountMail: false,

            saving: false,

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onPersonIdChanged = this.onPersonIdChanged.bind(this);

        this.switchContactEditMode = this.switchContactEditMode.bind(this);
        this.switchContactAddMode = this.switchContactAddMode.bind(this);
        this.updateContacts = this.updateContacts.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.onDeleteContact = this.onDeleteContact.bind(this);
        this.onEditContact = this.onEditContact.bind(this);
        // this.fetchAccountMail = this.fetchAccountMail.bind(this);

        this.fetchAccountMail = this.fetchAccountMail.bind(this);
        this.editAccountMail = this.editAccountMail.bind(this);
        this.switchAccountMailEditMode = this.switchAccountMailEditMode.bind(this);
    }

    componentDidMount() {
        // this.fetchAccountMail();
        axios.get('/user/current')
            .then(response => {
                const role = response.data;
                (role.substr(0, 8) === 'Student:' || role.substr(0, 11) === 'Diplomirani' || role.substr(0, 7) === 'Ispisan') ? this.setState({ activeRole: 'student' })
                    : role.substr(0, 8) === 'Profesor' ? this.setState({ activeRole: 'profesor' })
                        : role.substr(0, 8) === 'Asistent' ? this.setState({ activeRole: 'asistent' })
                            : role.substr(0, 10) === 'Studentska' ? this.setState({ activeRole: 'studentska' })
                                : null;
                request.fetchContactTypes()
                    .then(contactTypes => {
                        this.setState({ contactTypes }, () => {
                            this.onPersonIdChanged();
                        });
                    });
            })
            .catch(err => console.log('err'));
        this.fetchAccountMail();
        axios.get('/students/images/originals/from-authentication')
            .then(res => {
                res.data ?
                    this.setState({ src: res.data })
                    : this.setState({ src: null });
            }).catch(err => {
                this.setState({ src: null });
            });
    }

    fetchAccountMail() {
        let obj = {
            id: this.props.studentId
        };
        axios.post('/user/get-user-data/', { ...obj })
            .then(res => {
                // eslint-disable-next-line no-unused-expressions
                res.data ?
                    this.setState({ accountMail: res.data.eMail, username: res.data.username, loading: false })
                    : this.setState({ accountMail: null });
            }).catch(err => {
                this.setState({ accountMail: null });
            });
    }
    switchAccountMailEditMode() {
        this.setState({ editAccountMail: !this.state.editAccountMail });
    }

    editAccountMail(accountMail) {
        axios.put('user/edit-user-mail/0/', accountMail)
            .then((res) => {
                this.fetchAccountMail();
                this.switchAccountMailEditMode();
                toast(<FormattedMessage id="student.emailEditSuccess" />);
            })
            .catch(err => {
                toast(<FormattedMessage id="student.emailEditError" />);
            });
    }

    onPersonIdChanged() {
        if (this.props.location.pathname === '/lični-podaci-studenta' || this.props.location.pathname === '/osobni-podaci-studenta' || this.props.location.pathname === '/student-personal-information') {
            fetchPersonInfo(this.state.activeRole, this.state.contactTypes)
                .then(personData => {
                    this.setState({ personData });
                    this.setState({ loading: false });
                });
            fetchCurrentStudyProgramInfo('student', '', '')
                .then(currentStudyProgramInfo => {
                    this.setState({
                        currentStudyProgramInfo: currentStudyProgramInfo.data,
                        faculties: currentStudyProgramInfo.data.faculties,
                        departments: currentStudyProgramInfo.data.department
                    });
                });
        }

        if (this.props.location.pathname === '/spisak-studenata/lični-podaci' || this.props.location.pathname === '/upis-studenta-u-semestar/lični-podaci') {
            fetchPersonInfo('studentska', this.state.contactTypes, this.props.location.state.studentId)
                .then(personData => {
                    this.setState({ personData });
                    this.setState({ loading: false });
                });
            fetchCurrentStudyProgramInfo(this.state.activeRole, this.props.location.state.studentId, this.props.location.state.studyProgramId)
                .then(currentStudyProgramInfo => {
                    this.setState({
                        currentStudyProgramInfo,
                        faculties: currentStudyProgramInfo.faculties,
                        departments: currentStudyProgramInfo.department
                    });
                });
        }
    }


    onDeleteContact(contactId) {
        if (this.props.location.pathname === '/spisak-studenata/lični-podaci' || this.props.location.pathname === '/upis-studenta-u-semestar/lični-podaci') {
            deleteContact(contactId, this.state.activeRole, this.props.location.state.studentId)
                .then(res => { toast(<FormattedMessage id="student.deleteContactToast" />); this.updateContacts(); });
        }
        if (this.props.location.pathname === '/lični-podaci-studenta' || this.props.location.pathname === '/osobni-podaci-studenta' || this.props.location.pathname === '/student-personal-information') {
            deleteContact(contactId, this.state.activeRole)
                .then(res => { toast(<FormattedMessage id="student.deleteContactToast" />); this.updateContacts(); });
        }
    }


    onEditContact(requestBody) {
        axios.put('/students/student/personal-information/change-contact', { ...requestBody })
            .then(res => {
                toast(<FormattedMessage id="student.editContactToast" />);
                this.updateContacts();
            })
            .catch(err => {
                toast(<FormattedMessage id="student.editContactErrToast" />);
            });
    }

    onAddNewContact(contact) {
        if (this.props.location.pathname === '/spisak-studenata/lični-podaci' || this.props.location.pathname === '/upis-studenta-u-semestar/lični-podaci') {
            addContact(contact, this.state.contactTypes, this.state.activeRole, this.props.location.state.studentId)
                .then(res => { toast(<FormattedMessage id="student.addContactToast" />); this.updateContacts(); });
        }
        addContact(contact, this.state.contactTypes, this.state.activeRole)
            .then(res => { toast(<FormattedMessage id="student.addContactToast" />); this.updateContacts(); });
    }


    switchContactEditMode() {
        this.setState(prevState => ({ contactEditMode: !prevState.contactEditMode }));
    }
    updateContacts() {
        if (this.props.location.pathname === '/lični-podaci-studenta' || this.props.location.pathname === '/osobni-podaci-studenta' || this.props.location.pathname === '/student-personal-information') {
            fetchPersonInfo(this.state.activeRole, this.state.contactTypes)
                .then(personData => {
                    this.setState({ personData });
                    this.setState({ loading: false });
                });
        }
        if (this.props.location.pathname === '/spisak-studenata/lični-podaci' || this.props.location.pathname === '/upis-studenta-u-semestar/lični-podaci') {
            fetchPersonInfo(this.state.activeRole, this.state.contactTypes, this.props.location.state.studentId)
                .then(personData => {
                    this.setState({ personData });
                    this.setState({ loading: false });
                });
        }
    }
    switchContactAddMode() {
        this.setState(prevState => ({ contactAddMode: !prevState.contactAddMode }));
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    setContactConsent(contactConsent) {
        this.setState({ saving: true });
        axios.put(`/students/set-contact-consent/${this.state.personData.id}/${contactConsent}`)
            .then(res => {
                this.setState({
                    saving: false,
                    personData: {
                        ...this.state.personData,
                        contactConsent: contactConsent
                    }
                });
                toast(contactConsent ? <FormattedMessage id="student.contactConsentGiven" /> : <FormattedMessage id="student.contactConsentWithdrawn" />)
            })
            .catch(err => {
                this.setState({
                    saving: false
                });
                toast(<FormattedMessage id="common.error" />)
            });
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const srcAvatar = 'https://image.freepik.com/free-icon/user-image-with-black-background_318-34564.jpg';
        const {
            currentStudyProgramInfo,
            personData,
            accountMail,
            username,
            editAccountMail
        } = this.state;
        if (this.state.step === 1) {
            return (
                <StudentEdit
                    studentId={this.props.location.state.studentId}
                    studyProgramId={this.props.location.state.studyProgramId}
                    changeStep={() => this.setState({ step: 0 })}
                />);
        }
        const activeRole = localStorage.getItem('activeRole') || ' ';
        return (
            <div >
                <Header as="h1"><FormattedMessage id="common.personalInfo" /></Header>

                <Grid columns={2} className="stackable" >
                    <Grid.Column >
                        {(this.props.location.pathname === '/spisak-studenata/lični-podaci' || this.props.location.pathname === '/upis-studenta-u-semestar/lični-podaci') &&
                            <Button color="blue" basic="true" disabled="true" fluid onClick={() => this.setState({ step: 1 })}><FormattedMessage id="student.editStudentData" /></Button>}

                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="student.basicInfo" /></Header>
                            </Segment>
                            <Segment>
                                <div style={{ textAlign: 'center' }}>
                                    <Image src={this.state.src ? `data:image/jpeg;base64,${this.state.src}` : srcAvatar} size="small" circular centered />
                                </div>
                                <PersonBasicInfoTable personInfoData={personData} />
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                    <Grid.Column >
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="student.accountInfo" />
                                    {(activeRole.substr(0, 11) !== 'Diplomirani' && activeRole.substr(0, 7) !== 'Ispisan') && <Header style={IconHeader} floated="right" >
                                        <Icon />
                                        <Icon
                                            link
                                            circular
                                            basic="true"
                                            floated="right"
                                            name={this.state.editAccountMail ? 'close' : 'pencil'}
                                            color={this.state.editAccountMail ? null : 'green'}
                                            onClick={this.switchAccountMailEditMode}
                                        />
                                    </Header>}

                                </Header>
                            </Segment>
                            <Segment>
                                <AccountInfo
                                    accountMail={accountMail}
                                    username={username}
                                    editAccountMailFlag={editAccountMail}
                                    editAccountMail={this.editAccountMail}
                                />
                            </Segment>
                        </Segment.Group>
                        <Segment.Group raised>
                            <Segment clearing>
                                <Header as="h3">
                                    <FormattedMessage id="common.contact" />
                                    {(this.props.location.pathname === '/lični-podaci-studenta' || this.props.location.pathname === '/osobni-podaci-studenta' || this.props.location.pathname === '/student-personal-information') &&

                                    <Header style={IconHeader} floated="right" onClick={this.switchContactEditMode}>
                                        {localStorage.getItem('activeRole').substr(0, 8) === 'Student:' && <Button
                                            basic
                                            color="blue"
                                            size="small"
                                            style={RightHeaderWithButton}
                                            onClick={this.onNewSelection}
                                        >
                                            {!this.state.contactEditMode ? <FormattedMessage id="common.editAdd" /> : <FormattedMessage id="common.cancelO" />}
                                        </Button>}
                                    </Header>}

                                </Header>
                            </Segment>
                            <Segment style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <Checkbox
                                    disabled={this.state.saving}
                                    checked={!!this.state.personData.contactConsent}
                                    onChange={() => this.setContactConsent(!this.state.personData.contactConsent)}
                                />
                                <Fragment>
                                    <FormattedMessage id="student.consentInfo" />
                                </Fragment>
                            </Segment>
                            <ContactFormEditable
                                contacts={this.state.personData.contacts || []}
                                contactEditMode={this.state.contactEditMode}
                                contactTypes={this.state.contactTypes}
                                onAddNewContact={this.onAddNewContact}
                                onDeleteContact={this.onDeleteContact}
                                onEditContact={this.onEditContact}

                            />
                        </Segment.Group>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="student.previousEducation" /></Header>
                            </Segment>
                            <Segment>
                                <PreviousEducation
                                    studentId={(this.props.location.pathname === '/spisak-studenata/lični-podaci' || this.props.location.pathname === '/upis-studenta-u-semestar/lični-podaci')
                                        ? this.props.location.state.studentId : null}
                                />
                            </Segment>
                        </Segment.Group>
                        {!this.props.isEmployee && <Segment.Group raised>
                            {localStorage.getItem('activeRole').substr(0, 8) === 'Student:' ? <Segment>
                                <Header as="h3"><FormattedMessage id="student.currentStudy" /></Header>
                            </Segment>
                                : <Segment>
                                    <Header as="h3"><FormattedMessage id="student.study" /></Header>
                                </Segment>}
                            <Segment>
                                <CurrentStudyTable
                                    currentStudyProgramInfo={currentStudyProgramInfo}
                                    faculties={this.state.faculties}
                                    departments={this.state.departments}
                                />
                            </Segment>
                        </Segment.Group>}
                    </Grid.Column>
                </Grid>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/PersonalInfo.js